<template>
  <a-button type="primary" :loading="loading" @click="submitApproval"> 提交审批 </a-button>
</template>

<script>
import { defineComponent } from "vue";
import { ApprovalFlowService } from "../approval-flow.service";
import { message } from "ant-design-vue";
import { useFlowEmitter } from "@/utils/emitter";
export default defineComponent({
  name: "submit-approval-btn",
  props: {
    bizId: {
      type: String,
      required: true,
    },
    bizType: {
      type: String,
      required: true,
    },
    bizName: {
      type: String,
      required: true,
    },
    loading: {
      type: Boolean,
    },
  },
  emits: ["refresh", "update:loading"],
  setup(props, { emit }) {
    const { emitEvent } = useFlowEmitter();
    const { run } = ApprovalFlowService.useSubmitApi();
    const submitApproval = async () => {
      try {
        emit("update:loading", true);
        const { bizId, bizType, bizName } = props;
        let res = await run({ bizId, bizType, bizName });
        if (res.respCode !== "0000") {
          // message.error(res.respDesc);
          return;
        }
        emitEvent(bizId);
        message.success(res.respDesc);
        emit("refresh", null);
      } finally {
        emit("update:loading", false);
      }
    };

    return {
      run,
      submitApproval,
    };
  },
});
</script>

<style scoped></style>
